var _a, _b;
import { OtpErrorTypes } from '../typings';
import { BUSINESS_ERROR_CODES } from './status-and-error-codes';
export var INPUT_MISSING_DETAILS = 'missing input details';
export var PAGE_NAME = {
    ADDITION: 'addition',
    API_FAILURE: 'api failure',
    COMPLETE: 'complete',
    ERROR: 'error',
    IDENTITY_FAILURE: 'identity failure',
    INCORRECT_NAME: 'incorrect user name',
    LIMIT_REACHED: 'limit reached',
    NOT_ELIGIBLE_ADDRESS: 'not eligible address change',
    NOT_ELIGIBLE_FIRST_NAME: 'not eligible firstname change',
    SERVER_ERROR: 'server_error',
    START: 'start',
    USER_DECLINE: 'user decline'
};
export var SAMS_PAGE_NAME = {
    ADD_DOB: 'add dob sams',
    API_ERROR: 'api error sams',
    EXPIRED_MEMBERSHIP: 'membership expired sams',
    NO_ELIGIBLE_MEMBERS_FOUND: 'no eligible members sams',
    NOT_ELIGIBLE_MEMBERS: 'not eligible sams',
    NOT_VERIFIED: 'not verified sams',
    LIMIT_REACHED: 'max users sams',
    SELECTION: 'selection sams',
    START_VERIFIED: 'start sams verified',
    SUCCESS: 'success sams'
};
export var ANALYTICS_PAYLOAD = (_a = {},
    _a[BUSINESS_ERROR_CODES.ADDRESS] = {
        pageName: PAGE_NAME.NOT_ELIGIBLE_ADDRESS
    },
    _a[BUSINESS_ERROR_CODES.FIRST_NAME] = {
        pageName: PAGE_NAME.NOT_ELIGIBLE_FIRST_NAME
    },
    _a[BUSINESS_ERROR_CODES.PROFANITY] = {
        pageName: PAGE_NAME.INCORRECT_NAME
    },
    _a[OtpErrorTypes.USER_DECLINED] = {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.USER_DECLINED
    },
    _a[OtpErrorTypes.ACCESS_DENIED] = {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.ACCESS_DENIED
    },
    _a.api_failure = {
        pageName: PAGE_NAME.API_FAILURE
    },
    _a);
export var SAMS_ANALYTICS_PAYLOAD = (_b = {},
    _b[BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP] = {
        pageName: SAMS_PAGE_NAME.EXPIRED_MEMBERSHIP
    },
    _b[BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND] = {
        pageName: SAMS_PAGE_NAME.NO_ELIGIBLE_MEMBERS_FOUND
    },
    _b[BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS] = {
        pageName: SAMS_PAGE_NAME.NOT_ELIGIBLE_MEMBERS
    },
    _b[OtpErrorTypes.USER_DECLINED] = {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.USER_DECLINED
    },
    _b[OtpErrorTypes.ACCESS_DENIED] = {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.ACCESS_DENIED
    },
    _b.api_error = {
        pageName: SAMS_PAGE_NAME.API_ERROR
    },
    _b);
export var DEFAULTS = {
    CUSTOMER_TYPE: 'consumer',
    DEVICE: '<mobi/desk/tab>',
    ERROR_MESSAGE: '',
    MESSAGE: '',
    PAGE_FUNCTION: '',
    PAGE_KIND: '',
    PAGE_NAME: '',
    PNL: 'vista',
    PRODUCT: 'generic',
    SITE_IDENTIFIER: 'vista',
    SUB_FUNCTION: ''
};
